module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v2_common/light-fa031e9390a1af5610b7d28fa1f958fa.svg";